import { Component, inject, Input } from '@angular/core';
import { CreativeGalleryBase } from '../../types';
import { ShortNumberPipe } from '../../../../pipes/short-number.pipe';
import { PercentagePipe } from '../../../../pipes/percentage.pipe';
import { CardPopoverComponent } from './card-popover/card-popover.component';
import { NgIf } from '@angular/common';
import { ATTENTION_METRIC_NAME } from '../../../../shared/types/common';

@Component({
  selector: 'app-creative-gallery-card',
  imports: [CardPopoverComponent, NgIf, PercentagePipe],
  providers:[ShortNumberPipe, PercentagePipe],
  templateUrl: './creative-gallery-card.component.html',
  styleUrl: './creative-gallery-card.component.scss'
})
export class CreativeGalleryCardComponent {
  @Input() cardData!: CreativeGalleryBase;
  public isHovered = false;
  public isLogoHovered = false;
  protected cpm!: string;
  public attentionMetricName = ATTENTION_METRIC_NAME; 

  ngOnInit(): void {
    this.cpm = `$${this.cardData?.cpm.toFixed(2) || '0.00'}`;
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'images/no-logo.png';
  }
}
